import BaseController from "../pages/sharedControllers/BaseController";
import { BusinessUnitAndPartnerSelectData } from "../models/ExceptionSelectData";

export default class DependentBusinessUnitPartnerDataUtil {
  private controller: BaseController;

  constructor(controller: BaseController) {
    this.controller = controller;
  }

  public async UpdateSelectData(
    businessUnitId: number | string | undefined,
    partnerId: number | string | undefined,
    responseModelName: string
  ): Promise<BusinessUnitAndPartnerSelectData> {
    const businessUnitPartnerData = {
      businessUnitId,
      partnerId,
    };

    const response =
      await this.controller.fetchModelPost<BusinessUnitAndPartnerSelectData>(
        "api/BusinessUnitPartnerOption/GetBusinessUnitPartnerOptions",
        responseModelName,
        {
          body: businessUnitPartnerData,
        }
      );

    return response;
  }
}
